import React from 'react';
import useSectionView from '../../hooks/useSectionView';

const QUOTES = [
  {
    quote: 'I like that I can keep up with my quarterly payments, and see when my year will start to slow down so I can prepare for it before it happens',
    name: 'Sing',
    shop: 'Invisible Dents',
  },
  {
    quote: 'TruFlow has helped me get ahead of my finances while also freeing up my mental space to focus on more important things',
    name: 'Frank',
    shop: 'Total Dent Repair',
  },
];

function SocialProof() {
  const sectionRef = useSectionView('section_viewed_social_proof');
  return (
    // Deliberately lighter than the sections around it: half the vertical
    // padding, an eyebrow instead of a 36px serif heading, and a rule accent
    // rather than a card. This is a confidence beat between the hero and How It
    // Works, not somewhere the page should ask the reader to stop.
    <section ref={sectionRef} style={{ backgroundColor: 'var(--card)', padding: '48px 24px' }}>
      {/* 800px / 1fr 1fr / 24px gap matches Pricing.js — the other two-column
          grid on this page — so the columns line up between sections. */}
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <p style={{
          fontFamily: 'var(--font-sans)',
          fontSize: '13px',
          fontWeight: 500,
          color: 'var(--signal)',
          textTransform: 'uppercase',
          letterSpacing: '1.5px',
          textAlign: 'center',
          margin: '0 0 32px 0',
        }}>
          PDR techs using TruFlow
        </p>

        <div className="sp-grid" style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '24px',
          alignItems: 'start',
        }}>
          {QUOTES.map(({ quote, name, shop }) => (
            <figure key={name} style={{
              margin: 0,
              borderLeft: '2px solid var(--signal-border)',
              paddingLeft: '20px',
            }}>
              <blockquote style={{
                margin: 0,
                fontFamily: 'var(--font-serif)',
                fontSize: '17px',
                color: 'var(--ink)',
                lineHeight: 1.55,
              }}>
                {`“${quote}”`}
              </blockquote>
              {/* Name and shop share one muted line, and the shop is set as
                  plain text at the same size — it should read as a business
                  someone could look up, not as decoration. */}
              <figcaption style={{
                fontFamily: 'var(--font-sans)',
                fontSize: '13px',
                color: 'var(--mute)',
                margin: '12px 0 0 0',
              }}>
                <span style={{ fontWeight: 500 }}>{name}</span>
                {`, ${shop}`}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 640px) {
          .sp-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}

export default SocialProof;
